import * as React from 'react'
function SvgDataHealth(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M24 34c-.8 0-1.6-.6-1.8-1.4l-6.6-19.4-3.8 7.6c-.4.8-1 1.2-1.8 1.2H6a2 2 0 110-4h2.8l5.4-10.8c.4-.8 1.2-1.2 2-1.2s1.4.6 1.8 1.4l6.4 19.4 3.8-7.6c.4-.8 1-1.2 1.8-1.2h4a2 2 0 110 4h-2.8l-5.4 10.8c-.4.8-1 1.2-1.8 1.2z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgDataHealth
